import React, { Component } from "react";
import CommonBreadCrumb from "./commonPageHeader/CommonBreadCrumb";

class CommonPageHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }
    render() {
    const basename = process.env.PUBLIC_URL || "/sms";

    const breadcrumb = [
        // { title: 'Overview', link: '/overview', icon: `${basename}/images/nav/home.png` },
        { title: 'Dashboard', link: '/dashboard', icon: `${basename}/images/nav/newTheme/Dashboard.svg` },
        { title: 'Campaign', link: '/campaign', icon:`${basename}/images/nav/newTheme/Campaign.svg` },
        { title: 'Analytics', link: '/analytics', icon:`${basename}/images/nav/newTheme/Analytics.svg` },
        
    ];

    return (
        // <div style={{ borderRadius: "9px", padding: "10px", backgroundColor: "white", minHeight: "35px" }}>
        <div style={{ paddingLeft: "20px", paddingRight: "20px", textAlign: "center" }}>
            <CommonBreadCrumb breadcrumbs={breadcrumb} />
        </div>    
    )
    }
}

export default CommonPageHeader;


// WEBPACK FOOTER //
// ./src/modules/common/components/CommonPageHeader.js